import Vue from 'vue'
import Vuex from 'vuex'
import RouterState from './modules/route'
import user from './modules/user'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        RouterState,
        user
    },
    getters

})

export default store